// g
export const GOAL_LIST = "GOAL_LIST";
export const GOAL_EDIT = "GOAL_EDIT";
export const GOAL_NEW = "GOAL_NEW";

// h
export const HABIT = "HABIT";
export const HABIT_ENTRY = "HABIT_ENTRY";
export const HABIT_CHART = "HABIT_CHART";

// m
export const METRIC_CHART = "METRIC_CHART";

// n
export const NOTIFICATION_PREFERENCE = "NOTIFICATION_PREFERENCE";

// local storage consts
export const CURRENT_URL = "CURRENTURL";
